<template lang="pug">
  .hoursReport
    el-container
      el-header
        el-row(:gutter="20" style="overflow:hidden;")
          el-col(:span="1.5" style="float:left")
            .grid-content.bg-purple(
              style="border-bottom:3px solid var(--theme-color);font-weight: bold;font-size:18px;") 工时填报
      el-main(style="display: flex;flex-direction: column;")
        el-row.search-pane
          .table_box
            .data-button
              el-button(@click="addWeekHandler(-1)" :disabled='minuWeeks>3' size="small") &lt;
              span 第{{ currentWeekData.number }}周 ({{ currentWeekData.days[0].date }} 至 {{ currentWeekData.days[6].date }})
              el-button(@click="addWeekHandler(1)" size="small") &gt;
            ul.status-list
              li(v-for="(status,index) in statusDic.slice(1,6)" :key="status.title")
                i(:class="status.className")
                span {{status.title}}
        .table-do
          el-button.el-icon-circle-plus-outline(
            @click="addNewTaskHandler()"
            v-if="dateDisabledIndex>0"
            type="primary" size="small") 新增工时填报
          el-button.pull-right(type="primary" @click="submissionHandler()" size="small") 全部提交
        div(style="width:100%;height: 1px;flex-grow: 1;")
          el-table.sydneyTable(
            show-summary
            :summary-method="getSummaries"
            :data="taskList"
            tooltip-effect="dark"
            :key="keyTable"
            height='100%'
            size="medium"
            border)
            el-table-column(type="index" label="序号" width="60")
            el-table-column(label="是否项目" width="80" prop="isProject")
              template(slot-scope="{row}")
                el-switch(
                  v-model="row.isProject"
                  :disabled="!row.$isEdit||!row.$isAdd"
                  @change="changeIsProjectHandler(row)"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="0"
                  inactive-value="1")
            el-table-column(label="部门名称" width="120" prop="projectId")
              template(slot-scope="{row}")
                el-select(
                  v-model="row.projectID"
                  @change="changeProjectHander(row)"
                  v-if="!!row.$isEdit&&!!row.$isAdd"
                  placeholder="请选择部门"
                  size="small")
                  el-option(
                    v-for="item in deptMapList"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId")
                span(v-else) {{row.projectName}}
            el-table-column(label="项目名称" width="140" prop="itemID")
              template(slot-scope="{row}")
                el-select(
                  v-model="row.itemID"
                  @change="changeItemIdHandler(row)"
                  v-if="!!row.$isEdit&&!!row.$isAdd"
                  filterable
                  placeholder="请选择项目"
                  size="small")
                  el-option(
                    v-for="item in itemsList[row.isProject]"
                    :key="item.prjId"
                    :label="item.prjName"
                    :value="item.prjId")
                span(v-else) {{row.itemName}}
            el-table-column(label="专业" width="100" prop="specName")
              template(slot-scope="{row}")
                el-select(
                  v-if="!!row.$isEdit&&!!row.$isAdd"
                  v-model="row.specId"
                  @change="changeSpecHandler(row)"
                  :disabled="row.isProject == '1' && row.itemID"
                  placeholder="请选择专业"
                  size="small")
                  el-option(
                    v-for="item in specMapList"
                    :key="item.specId"
                    :label="item.specName"
                    :value="item.specId")
                span(v-else) {{row.specName}}
            el-table-column(label="角色" width="130" prop="details")
              template(slot-scope="{row}")
                el-select(
                  v-model="row.dutyID"
                  @change="changeDutyHandler(row)"
                  v-if="!!row.$isEdit&&!!row.$isAdd"
                  :disabled="row.isProject == '1' && row.specId"
                  placeholder="请选择角色"
                  size="small")
                  el-option(
                    v-for="item in roleMapList"
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleId")
                span(v-else) {{row.dutyName}}
            el-table-column(
              v-for="(day,weekIndex) in currentWeekData.days"
              :label="day.cnWeek"
              :key="day.cnWeek")
              el-table-column(
                width="120"
                :prop="day.enWeek"
                :label="day.date.substring(5,10)")
                template(slot-scope="{row}")
                  el-input-number(
                    :value="row[day.enWeek].workTime"
                    @change="onChange(row,day.enWeek, day.date.substring(0,10), $event)"
                    controls-position="right"
                    style="width:105px"
                    v-if="(row.$isAdd || row.$isEdit) && row[day.enWeek].status != 2 && row[day.enWeek].openTime && !(row[day.enWeek].openTime > today)"
                    :precision="1"
                    :step="0.1"
                    :min="0"
                    :max="24"
                    size="small")
                  span.work-time(:class="`status_${row[day.enWeek].status == 2 ? row[day.enWeek].status * 1 + 1  : row[day.enWeek].status}`" v-else) {{row[day.enWeek].workTime}}
            el-table-column(label="总计"  width="100" fixed="right")
              template(slot-scope="{row}") {{getTaskRowSum(row)}}
            el-table-column(label="操作" fixed="right")
              template(slot-scope="{row,$index}")
                template(v-if="!!row.$isEdit")
                  el-button.actionBtn(
                    plain
                    type="primary"
                    size="mini"
                    @click="saveRowHandler(row,$index)") 保存
                  el-button.actionBtn(
                    plain
                    type="danger"
                    size="mini"
                    @click="cancelRowHandler(row,$index)") 取消
                  el-button.actionBtn(
                    plain
                    type="info"
                    size="mini"
                    :disabled='!!row.$isAdd'
                    @click="revocation(row, $index)") 撤回
                template(v-else)
                  el-button.actionBtn(
                    plain
                    type="primary"
                    size="mini"
                    @click="editRowHandler(row, $index)") 编辑
                  el-button.actionBtn(
                    plain
                    type="danger"
                    size="mini"
                    @click="deleteRowHandler(row,$index)") 删除
                  el-button.actionBtn(
                    plain
                    type="info"
                    size="mini"
                    @click="revocation(row, $index)") 撤回
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import manhourservice from "@/CommonDP/service/work-time/man-hour-service";
const formatStr = "YYYY-MM-DD";
moment.locale("zh-cn");

export default {
  name: "HoursReport",
  data() {
    return {
      today: moment(new Date()).format(formatStr),
      currentDate: moment().format(formatStr), // 显示的日期
      itemsList: [], // 真项目-列表
      taskList: [], // 任务列表
      deptMapList: [],
      specMapList: [],
      roleMapList: [],
      stageMapList: [],
      calendarShow: false,
      dicPage: {
        pageNo: 1,
        pageSize: 999
      },
      curRow: {},
      statusDic: [
        {
          title: "未保存",
          className: "status_"
        },
        {
          title: "未提交",
          className: "status_1"
        },
        {
          title: "已提交",
          className: "status_3"
        },
        {
          title: "撤回",
          className: "status_5"
        }
      ], // 未保存 前端特有

      minuWeeks: 0,
      isHasEdit: false,
      keyTable: 0
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    currentWeekData() {
      const { currentDate } = this;
      const dayCnList = ["一", "二", "三", "四", "五", "六", "日"];
      const dayEnList = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
      const weekInfo = {
        number: moment(currentDate).week(),
        days: dayCnList.map((cn, index) => {
          return {
            enWeek: dayEnList[index],
            cnWeek: `星期${cn}`,
            date: moment(currentDate).weekday(index).format(formatStr)
          };
        })
      };
      return weekInfo;
    },
    dateDisabledIndex() {
      const {
        currentWeekData: { number, days },
        currentDate
      } = this;
      const nowDate = moment();
      const index = days.findIndex(({ date }) => moment(date) > moment().startOf("day"));
      return index === -1 ? 100 : index;
    },
    allItemList() {
      const {
        itemsList: [sureList, noList]
      } = this;
      return [...sureList, ...noList];
    }
  },
  created() {
    this.getOptions();
    this.getWorkTimeList();
  },
  methods: {
    onChange(row, enWeek, date, val) {
      row[enWeek].openTime = date;
      row[enWeek].workTime = val;
    },
    getOptions() {
      const enterpriseId = this.enterpriseId;
      manhourservice
        .getOptions({ enterpriseId })
        .then((res) => {
          if (res.result == "0") {
            const { deptMapList, prjMapList, specMapList, roleMapList, stageMapList } = res.data;
            this.deptMapList = deptMapList;
            this.rawSpecMapList = specMapList;
            this.rawRoleMapList = roleMapList;
            this.rawStageMapList = stageMapList;

            const itemsList = [[], []];
            prjMapList.forEach((item) => {
              itemsList[item.isProject].push(item);
            });
            this.itemsList = itemsList;
          } else {
            this.$warning(res.message);
          }
        })
        .catch((e) => {
          console.log(e, "getOptions");
        });
    },
    // 获取时间段内提交的工时
    getWorkTimeList() {
      const {
        currentWeekData: { days },
        data2List
      } = this;
      const params = { startDate: days[0].date, endDate: days[6].date, enterpriseId: this.enterpriseId };
      return manhourservice
        .workTimeHomeList(params)
        .then(({ data }) => {
          const taskList = data ? data.map(data2List) : [];
          this.taskList = taskList;
          this.keyTable += 1;
        })
        .catch((e) => {
          console.log(e, "getWorkTimeList");
        });
    },

    // 修改项目
    changeItemIdHandler(row) {
      const { allItemList } = this;
      row.itemName = (allItemList.find((item) => item.prjId === row.itemID) || {}).prjName;
      if (row.isProject === "0") {
        this.getSpecList(row.itemID);
        row.specId = "";
        row.changeItemIdHandler = "";
        row.dutyID = "";
        row.dutyName = "";
      }
    },

    getDutyList(id1, id2) {
      const params = {
        prjId: id1,
        specId: id2,
        enterpriseId: this.enterpriseId
      };
      manhourservice.getDutyList(params).then((res) => {
        if (res.result == "0") {
          this.roleMapList = res.data;
        } else {
          this.$warn(res.message);
        }
      });
    },
    getSpecList(id) {
      const params = {
        prjId: id,
        enterpriseId: this.enterpriseId
      };
      manhourservice.getSpecList(params).then((res) => {
        if (res.result == "0") {
          this.specMapList = res.data;
        } else {
          this.$warn(res.message);
        }
      });
    },

    changeProjectHander(row) {
      const { deptMapList } = this;
      row.projectName = (deptMapList.find((project) => project.deptId === row.projectID) || {}).deptName;
    },
    // 单行合计
    getTaskRowSum(row) {
      const {
        currentWeekData: { days }
      } = this;
      const totalTime = Number(days.reduce((sum, { enWeek }) => Number(Number(row[enWeek].workTime || 0) + Number(sum)).toFixed(1), 0));
      row.totalTime = totalTime;
      return totalTime;
    },
    // 列 合计
    getSummaries({ columns, data }) {
      const sums = columns.map(({ label, property }, index) => {
        if (label === "职责") return "合计";
        else if (index > 5 && index < 13) {
          return Number(data.reduce((sum, row) => sum + Number((row[property] && row[property].workTime) || 0), 0).toFixed(1));
        }
      });
      sums[13] = sums.slice(6, 13).reduce((sum, num) => Number((num + sum).toFixed(1)), 0);
      return sums;
    },
    // 切换周 1为加一周  -1为减一周
    addWeekHandler(factor = 1) {
      if (factor === -1) {
        // 最多减四周
        if (this.minuWeeks < 4) this.minuWeeks++;
      } else {
        this.minuWeeks--;
      }
      const { currentDate } = this;
      const date = moment(currentDate);
      if (factor === 1) date.add(7, "d");
      else if (factor === -1) date.subtract(7, "d");
      else {
        // do nothing
      }
      const dateStr = date.format(formatStr);
      this.willChangeDate(dateStr);
    },
    switchOptions(isRaw) {
      if (isRaw) {
        const { rawRoleMapList, rawSpecMapList } = this;
        this.roleMapList = rawRoleMapList;
        this.specMapList = rawSpecMapList;
      } else {
        this.roleMapList = [];
        this.specMapList = [];
      }
    },
    // 切换是否项目
    changeIsProjectHandler(row) {
      const { roleMapList, stageMapList, specMapList } = this;
      const { isProject } = row;
      const str = isProject === "0" ? "" : "其他";
      row.itemName = "";
      row.itemID = "";
      if (str) {
        row.dutyID = roleMapList.find(({ roleName }) => roleName === "其他").roleId;
        row.stageID = stageMapList.find(({ stageName }) => stageName === "其他").stageId;
        row.specId = specMapList.find(({ specName }) => specName === "其他").specId;
        row.dutyName = row.specName = str;
      } else {
        this.switchOptions();
        row.dutyName = row.specName = row.dutyID = row.specId = "";
      }
    },
    changeSpecHandler(row) {
      const { specMapList } = this;
      const specName = specMapList.find(({ specId }) => specId === row.specId).specName;
      row.specName = specName;
      row.dutyID = "";
      row.dutyName = "";
      this.getDutyList(row.itemID, row.specId);
      // this.$set(row, 'specName', specName);
    },
    // 手动切换阶段
    changeStageHandler(row) {
      const { stageMapList } = this;
      const stage = stageMapList.find(({ stageId }) => stageId === row.stageID).stageName;
      this.$set(row, "stage", stage);
    },
    changeDutyHandler(row) {
      const { roleMapList } = this;
      const dutyName = roleMapList.find(({ roleId }) => roleId === row.dutyID).roleName;
      this.$set(row, "dutyName", dutyName);
    },

    revocation(row, index) {
      const {
        currentWeekData: { days }
      } = this;
      const status = row[days[index].enWeek].status; // 当前的格状态
      if (status == "2") {
        const params = {
          ids: []
        };
        days.forEach(({ enWeek }) => {
          const id = row[enWeek].id;
          if (id) params.ids.push(id);
        });
        manhourservice
          .workTimeWithdraw(params.ids)
          .then((res) => {
            if (res.result == "0") {
              this.getWorkTimeList();
            } else {
              this.$message.warning(res.message);
            }
          })
          .catch((err) => {
            this.$message.warning(err.message);
          });
      }
    },

    // 删除一行
    deleteRowHandler(row, index) {
      const {
        $confirm,
        currentWeekData: { days }
      } = this;
      $confirm("确定删除此工时?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const idList = [];
        days.forEach(({ enWeek }) => {
          const id = row[enWeek].id;
          if (id) idList.push(id);
        });
        manhourservice
          .workTimeBatchDelete(idList)
          .then((res) => {
            if (res.result == "0") {
              this.taskList.splice(index, 1);
            } else {
              this.$message.warning(res.message);
            }
          })
          .catch((err) => {
            console.log(err.message);
            // this.$message.warning(err.message);
          });
      });
    },
    // 编辑一行
    editRowHandler(row, index) {
      const {
        currentWeekData: { days }
      } = this;
      const status = row[days[index].enWeek].status; // 当前的格状态
      if (this.isHasEdit) {
        this.$warn("请先执行保存操作");
        return;
      }
      if (status != "2") {
        this.isHasEdit = true;
        this.$set(row, "$isEdit", true);
        this.curRow = JSON.parse(JSON.stringify(row));
      } else {
        this.$warn("请先执行撤回操作");
      }
    },
    cancelRowHandler(row, index) {
      this.$set(row, "$isEdit", false);
      if (row.$isAdd) {
        this.taskList.splice(index, 1);
      } else {
        this.isHasEdit = false;
        const {
          currentWeekData: { days }
        } = this;
        days.forEach(({ date, enWeek }, index) => {
          row[enWeek] = {
            id: this.curRow[enWeek].id,
            openTime: this.curRow[enWeek].openTime,
            overTime: this.curRow[enWeek].overTime,
            status: this.curRow[enWeek].status,
            workTime: this.curRow[enWeek].workTime
          };
        });
      }
    },
    // 此单元格可以编辑
    canEdit(row, index) {
      const {
        dateDisabledIndex,
        currentWeekData: { days }
      } = this;
      const { $isEdit, $isAdd } = row;
      const status = row[days[index].enWeek].status; // 当前的格状态
      const rowIsEdit = !!$isEdit; // 行
      const inputCanEdit = status !== "2"; // 列
      // todayCanEdit = index < dateDisabledIndex;
      return $isAdd || (rowIsEdit && inputCanEdit);
    },
    // 新增工时 - 点击保存按钮
    addNewTaskHandler() {
      const exsitAdd = this.taskList.some((item) => {
        return item.$isAdd;
      });
      if (exsitAdd) return this.$warn("请先保存新增数据再进行操作");
      const { data2List } = this;
      const task = data2List({
        $isEdit: true,
        $isAdd: true,
        $cancel: (index) => {
          const taskList = [...this.taskList];
          taskList.splice(index, 1);
          this.roleMapList = [];
          this.specMapList = [];
          this.$set(this, "taskList", taskList);
        }
      });
      this.taskList.push(task);
    },
    // 列表数据 转 接口数据
    list2data(row) {
      // 清空$xxx 和status和时间为0的数据
      const {
        currentWeekData: { days }
      } = this;
      const jsonStr = JSON.stringify(row);
      const workWeek = JSON.parse(jsonStr, (key, value) => {
        if (/^\$/.test(key)) return undefined;
        else return value;
      });
      // 清空为 时间0的数据
      days.forEach(({ enWeek, date }) => {
        const dayWork = workWeek[enWeek];
        delete dayWork.status;
        if (row.$isAdd) {
          if (dayWork.workTime === null) workWeek[enWeek] = null;
        } else {
          if (!dayWork.id) workWeek[enWeek] = null;
        }
      });
      workWeek.enterpriseId = this.enterpriseId;
      return workWeek;
    },
    // 接口返回数据转列表
    data2List(data) {
      const {
        currentWeekData: { days }
      } = this;
      const task = {
        isProject: "0",
        projectID: "",
        projectName: "",
        itemID: "",
        itemName: "",
        stage: "",
        stageID: "",
        dutyID: "",
        dutyName: "",
        specName: "",
        specId: "",
        totalTime: 0,
        $cancel: (index) => {
          const taskList = [...this.taskList];
          taskList[index] = this.data2List(data);
          this.roleMapList = [];
          this.specMapList = [];
          this.$set(this, "taskList", taskList);
        },
        ...data
      };
      days.forEach(({ date, enWeek }, index) => {
        if (!task[enWeek]) {
          task[enWeek] = {
            openTime: date,
            status: "0", // 前端特有,代表未保存
            workTime: !(date > this.today) ? 0 : null
          };
        }
      });
      return task;
    },
    // 保存
    saveRowHandler(row, index) {
      const workRow = this.list2data(row);
      const server = row.$isAdd
        ? manhourservice.workTimeAdd // 新增
        : manhourservice.workTimeUpdate; // 编辑
      const rowData = this.taskList.filter((item) => {
        return item.$isAdd && item !== row;
      });
      this.isHasEdit = false;
      server(workRow).then((data) => {
        if (data.result == "0") {
          this.getWorkTimeList().then(() => {
            this.taskList.push(...rowData);
            this.$message.success("保存成功");
            // this.specMapList = [];
            // this.roleMapList = [];
          });
        } else {
          this.$message.warning(data.message);
        }
      });
    },
    // 提交
    submissionHandler() {
      const { taskList, $message, $confirm } = this;
      if (taskList.length === 0) $message("当前没有可提交的工时");
      else if (taskList.some((row) => !!row.$isEdit)) this.$message("当前工时信息没有保存，请保存后提交");
      else {
        this.$confirm("确定提交这些工时?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 提交
          const idList = [];
          const form = {};
          taskList.forEach((row) => {
            const {
              currentWeekData: { days }
            } = this;
            days.forEach(({ enWeek }) => {
              const id = row[enWeek].id;
              if (id) idList.push(id);
            });
          });
          form.ids = idList.join(",");
          return manhourservice
            .workTimeSubmit(form)
            .then((data) => {
              $message({ message: "提交成功", type: "success" });
              this.getWorkTimeList();
            })
            .catch(() => {
              $message({ message: "提交失败", type: "error" });
            });
        });
      }
    },
    changeCurrentDate(date = "") {
      if (date) this.willChangeDate(date);
      this.calendarShow = !date;
    },
    // 切换时间
    dateChangeHandler(date) {
      this.currentDate = date;
      this.taskList = [];
      this.getWorkTimeList();
    },
    willChangeDate(date) {
      const { $confirm, currentDate, taskList, dateChangeHandler } = this;
      if (currentDate !== date) {
        const hasChange = taskList.some((task) => !!task.$isChange || !!task.$isNew || !!task.$isEdit);
        if (hasChange) $confirm(`还有未提交任务,是否切换时间到${date}?`, "警告").then(() => dateChangeHandler(date));
        else dateChangeHandler(date);
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.table-do {
  display: flex;
  justify-content: flex-start;
  margin: var(--middle-space) 0;
}
#demo {
  width: 100%;
  height: 100%;
  float: left;
}

.work-time {
  border-radius: 20px;
  display: block;
  text-align: center;
  line-height: 24px;
  margin: 8px auto;
  width: 4em;
  color: #000;
}

.status {
  &-list {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0;

    li {
      display: inline-block;
      font-size: 14px;
      line-height: 30px;

      > i {
        margin: 0 8px;
        vertical-align: text-bottom;
        width: 20px;
        height: 15px;
        border-radius: 2px;
        display: inline-block;
      }
    }
  }

  // 未提交
  &_1 {
    background-color: #eff4ff;
    color: #333;
  }

  &_2 {
    background-color: #f4b955;
    color: #fff;
  }

  &_3 {
    background-color: #90cda9;
    color: #fff;
  }

  &_4 {
    background-color: #f27982;
    color: #fff;
  }

  &_5 {
    background-color: #666;
    color: #fff;
    text-decoration-line: line-through;
  }
}

.sydneyTable.el-table {
  /deep/ th .cell,
  /deep/ td .cell {
    text-align: center;
  }
}

.hoursReport {
  background-color: #f0eeee;
  height: 100%;
  padding: var(--middle-space);
  position: relative;

  .el-container{
    height: 100%;
  }
}

.el-header {
  height: max-content !important;
  background-color: white;
  color: var(--theme-color);
  padding: var(--middle-space) var(--big-space);
  margin-bottom: var(--middle-space);
}

.el-main {
  background-color: white;
  padding: var(--middle-space) var(--big-space);
}

.calendar {
  float: right;
  margin-right: 40px;
}

.sydneyTable {
  font-size: 14px;
}

.page-handler {
  text-align: center;
  margin-top: 20px;
}

.total {
  text-align: right;
}

.total p {
  display: inline-block;
  font-size: 20px;
}

.total span {
  color: red;
  font-size: 20px;
}

.search-pane {
  border-bottom: 1px dashed #dcdbdb;
  padding: 0 0 var(--middle-space);

  .text-right {
    text-align: right;
  }
}

.data-1 {
  margin-top: 10px;
}

.addNew {
  cursor: pointer;
}

.data-button .el-button--medium {
  font-size: 25px;
  border: none;
}

.table_header .el-input__inner {
  border-radius: 30px;
}

.data-button {
  text-align: center;
}

.submission {
  float: right;
  margin-top: 80px;
  margin-right: 50px;
}

.table-bottom {
  border: 1px solid rgb(231, 229, 229);
  height: 40px;
  width: 760px;
  margin-left: 750px;
  margin-top: -10px;
}

.table-bottom span {
  display: inline-block;
  width: 7%;
  text-align: center;
}

.bottom-1 {
  font-size: 16px;
  display: inline-block;
  margin-top: 8px;
  margin-left: 5px;
  // margin-right: 5px;
}

.s-1 {
  font-size: 14px;
  margin-right: 42px;
}

.actionBtn{
  margin: 2px ;
}
</style>
